export default {
    methods: {
        maskWalletAddress: function (val) {
            return `${val.substring(0, 6)}...${val.substring(val.length - 4)}`
        }
    }
}
